// extracted by mini-css-extract-plugin
export default {"title":"DeleteEntryModal_title__wW4sz","btnGroup":"DeleteEntryModal_btnGroup__jXG-L","btn":"DeleteEntryModal_btn__Hbsdc"};